module.exports = __webpack_public_path__ + "static/6305-woodrose-19-965119e8576751a33ebacddfd4623250.jpg";